
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const RFQStatus = () => {
  return (
    <SettingsMetaData propertyName={"rfqStatus_pr"} viewPropertyName={"RFQ Status"} />
  );
}
export default RFQStatus;
